import { motion } from "framer-motion";

export default function FinalCTA({ onBuy }) {
  return (
    <section
      data-testid="final-cta-section"
      className="py-28 md:py-40 px-6 md:px-12 bg-ink text-white relative overflow-hidden"
    >
      <div className="absolute -top-20 -right-20 w-72 h-72 bg-orange rounded-full opacity-10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-blue rounded-full opacity-10 blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
          className="section-num text-orange mb-8 inline-flex"
        >
          Um último pensamento
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.05 }}
          className="font-display text-4xl md:text-6xl lg:text-7xl text-white leading-[1.02] mb-12"
        >
          E se o maior
          <br />
          <span className="brush-underline brush-underline-orange">obstáculo</span> fosses tu,
          <br />
          a impedir o teu
          <br />
          <span className="font-serif-display text-orange normal-case lowercase">próprio avanço?</span>
        </motion.h2>
        <motion.button
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.12 }}
          onClick={onBuy}
          data-testid="final-buy-button"
          className="btn-orange px-12 py-4"
        >
          Começar agora — 29,90€
        </motion.button>
        <p className="smallcaps text-white/60 mt-6">
          PDF · entrega imediata · pagamento seguro Stripe
        </p>
      </div>
    </section>
  );
}
